(ns client-portal.client.voice-insights.upsell.data
  (:require [shared.core.reactive :as re]
            [client-portal.client.core.data :as core.d]
            [client-portal.client.voice-insights.data :as vi.d]))

(def root-path [:voice-insights :upsell])

(re/reg-event-db
  :vi-upsell/initialize re/middleware
  (fn [db]
    (core.d/initialize-common-filters db)))
